import axios from "axios";

const { TokenLogout } = require("API/Logout/logout");


const url = process.env.REACT_APP_APPROVAL_URL;


export const HandleDelete = async (data, setIsLoading, hanleAlertOpen, handleGet,handleClose, handleCloseMain) => {
    setIsLoading(true);
    try {


        await axios.post(`${url}/delete_file`, {
            ...data
        }, {
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`
            }
        })
            .then((res) => {
                setIsLoading(false);
                hanleAlertOpen(res.data.message, "success");
                handleGet();
                handleClose();
                handleCloseMain()
            })
            .catch((err) => {
                setIsLoading(false);
                console.log(err);
                hanleAlertOpen(err.response && err.response.data.error ? err.response.data.error : "Something went wrong", "error");
            })
    }
    catch (error) {
        setIsLoading(false);
        console.log(error);
        if (error.response && error.response.status === 401) {
            TokenLogout(error);
        } else {
            hanleAlertOpen(error.response && error.response.data.error ? error.response.data.error : "Something went wrong", "error");
        }
    }
}